import { combineReducers } from 'redux'
import chatboxReducer from './chatboxReducer'

export default combineReducers({
  chatboxReducer
})